<div #list>
    <div (click)="onSelectedItem(i)" *ngFor="let item of testRelatedDocuments; index as i;"
         class="pathway-document-item">{{item.title}}</div>
</div>
